export default "__VITE_ASSET__d3141733__"